module.exports = __webpack_public_path__ + "static/media/Team 20 What Next_ - Antonia Amato.6e49ee21.png";